var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"userAuthenticationView"},[_c('b-row',{staticClass:"justify-content-center"},[_c('img',{staticClass:"d-block mx-auto logo",attrs:{"src":require("vue_root/assets/images/herculift-logo-full.png")}})]),_vm._v(" "),_c('b-row',{staticClass:"justify-content-center"},[_c('b-card',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }